import { SET_EXPORTDRIVER } from '../actions';

const exportdriver = (state = [], action) => {
  switch (action.type) {
	case SET_EXPORTDRIVER:
      return [...action.value];  
    default: return state;
  }
}

export default exportdriver;
